import { render, staticRenderFns } from "./GoBack.vue?vue&type=template&id=134a38fd&"
import script from "./GoBack.vue?vue&type=script&lang=js&"
export * from "./GoBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('134a38fd')) {
      api.createRecord('134a38fd', component.options)
    } else {
      api.reload('134a38fd', component.options)
    }
    module.hot.accept("./GoBack.vue?vue&type=template&id=134a38fd&", function () {
      api.rerender('134a38fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/GoBack.vue"
export default component.exports